<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

const props = defineProps<{
  defaultValue?: string | number;
  modelValue?: string | number;
  class?: HTMLAttributes['class'];
  format?: (value: string) => string;
}>();

const emits = defineEmits<{
  (e: 'update:modelValue', payload: string | number): void;
}>();

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
});

const onInput = (e: Event) => {
  if (!(e.target instanceof HTMLInputElement)) return;
  // Written back to the DOM: a rejected keystroke leaves the model unchanged, so no re-render would erase it.
  if (props.format) e.target.value = props.format(e.target.value);
  modelValue.value = e.target.value;
};
</script>

<template>
  <input
    :value="modelValue"
    @input="onInput"
    :class="
      cn(
        'flex h-10 w-full scroll-mb-6 scroll-mt-8 rounded-md border border-gray-300 bg-transparent px-3 py-1 text-base transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground autofill:shadow-autofill-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary-500 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-950 disabled:opacity-50 md:text-sm',
        props.class,
      )
    "
  />
</template>
